import { ConnectError } from '@connectrpc/connect';
import { createActionGroup, props } from '@ngrx/store';
import { Job } from '@sites/data-hmm/hmm-job';

export const jobServiceActions = createActionGroup({
  source: 'DashboardFeatureJob JobService',
  events: {
    listSuccess: props<{ jobs: Array<Job> }>(),
    listFailure: props<{ error: ConnectError }>(),
    upsertJob: props<{ job: Job }>(),
    watchSuccess: props<{ job: Job }>(),
    watchFailure: props<{ error: ConnectError }>(),
    cancelSuccess: props<{ job: Job }>(),
    cancelFailure: props<{ error: ConnectError }>(),
  },
});
